import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import type { CoreGraphqlEntryProps } from "@/types/page";
import { useModuleQuoteQuery } from "@/components/contentful/module-quote/__generated/module-quote.contentful.generated";
import { ModuleQuote } from "@/components/contentful/module-quote/module-quote";
import { type MicrocopyInputType } from "@/lib/contentful/microcopy/microcopy-context";

export type ModuleQuoteGraphqlProps = CoreGraphqlEntryProps & {
    isEmbedded?: boolean;
};

export const ModuleQuoteGraphql = ({
    id,
    locale,
    preview,
    isEmbedded,
}: ModuleQuoteGraphqlProps) => {
    const { data, isLoading } = useModuleQuoteQuery(
        {
            id,
            locale,
            preview,
        },
        {
            ...(!preview && { staleTime: Infinity }),
            refetchOnWindowFocus: false,
        }
    );

    const queryResult = useContentfulLiveUpdates(data, { locale });

    const microcopySets: MicrocopyInputType[] =
        queryResult?.microcopySetCollection?.items?.filter((item) => item !== null) ?? [];

    if (isLoading || !queryResult?.moduleQuote) {
        return null;
    }

    return (
        <ModuleQuote
            {...queryResult?.moduleQuote}
            microcopySets={microcopySets}
            isEmbedded={isEmbedded}
        />
    );
};
